import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import ApiRequest from "../../../utils/ApiRequest";
import ExportToolbarButton from "./ExportToolbarButton";

/**
 * CSV export via ApiRequest (legacy settlement/org APIs). V2-styled control only.
 */
export default function CsvDownApi({
  digit = 0,
  headers,
  url,
  params,
  type = "",
  title = "Download CSV",
  contentType,
  reportName = "Report.csv",
  method = "post",
}) {
  const [data, setData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [triggerDownload, setTriggerDownload] = useState(false);
  const csvLinkRef = useRef(null);

  useEffect(() => {
    if (triggerDownload && data.length > 0 && csvLinkRef.current) {
      csvLinkRef.current.link.click();
      setTriggerDownload(false);
    }
  }, [data, triggerDownload]);

  const downloadReport = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    getUserList();

    setTimeout(() => {
      setIsDisabled(false);
    }, 15000);
  };

  const getUserList = () => {
    const successHandler = (res) => {
      let contentData = [];

      try {
        if (Array.isArray(res?.data?.metaInfo?.data)) {
          contentData = res.data.metaInfo.data;
        } else if (Array.isArray(res?.data?.data?.data)) {
          contentData = res.data.data.data;
        } else if (Array.isArray(res?.data)) {
          contentData = res.data;
        } else if (Array.isArray(res?.data?.data?.content)) {
          contentData = res.data.data.content;
        } else if (Array.isArray(res?.data?.data?.transactions)) {
          contentData = res?.data?.data?.transactions;
        }
        if (digit === 1) {
          contentData = contentData.map((value) => ({
            ...value,
            transactionId: "txn_" + value.transactionId,
          }));
        }

        setData(contentData);
        setTriggerDownload(true);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("CSV Download parsing error:", err);
      }
    };

    const errorHandler = (err) => {
      // eslint-disable-next-line no-console
      console.error("CSV Download API Error:", err);
    };

    const api = new ApiRequest("", successHandler, errorHandler, false);
    if (method === "post") {
      api.post(url, params);
    } else {
      api.get(url);
    }
  };

  return (
    <>
      {data.length > 0 && (
        <CSVLink className="hidden" data={data} headers={headers} filename={reportName} ref={csvLinkRef}>
          {""}
        </CSVLink>
      )}

      {url ? (
        <ExportToolbarButton loading={isDisabled} onClick={downloadReport}>
          {title}
        </ExportToolbarButton>
      ) : (
        <ExportToolbarButton disabled>{title}</ExportToolbarButton>
      )}
    </>
  );
}
